import React from "react";
import { Axis, Cell, CrmScoringUser, SortBy, SortOrder } from "../../actions/crmScoring"
import { Box, Center, Group, Loader, ThemeIcon, Title } from "@mantine/core";
import { SquaresFourIcon } from "@phosphor-icons/react";
import AxisTabs from "./AxisTabs";
import DateRangeFilter from "./DateRangeFilter";
import ScoringMatrix from "./ScoringMatrix";
import SegmentUserList from "./SegmentUserList";

interface Props {
  clientId: number
  axis: Axis
  dateRange: { start: string; end: string }
  matrix: { total: number; cells: Cell[]; loading: boolean }
  selectedCells: Array<[number, number]>
  users: { items: CrmScoringUser[]; total: number; page: number; perPage: number; loading: boolean }
  sort: { sortBy: SortBy; sortOrder: SortOrder }
  snapshotDate: string
  searchQuery: string
  checkedUserIds: number[]
  onAxisChange: (axis: Axis) => void
  onDateRangeChange: (start: string, end: string) => void
  onToggleCell: (x: number, y: number) => void
  onClearSelectedCells: () => void
  onSearchQueryChange: (q: string) => void
  onSetCheckedUsers: (ids: number[]) => void
  onPageChange: (page: number) => void
  onPerPageChange: (perPage: number) => void
  onSortChange: (sortBy: SortBy, sortOrder: SortOrder) => void
  onSnapshotDateChange: (snapshotDate: string) => void
  onCsvDownload: () => void
  csvLoading: boolean
}

const CrmScoringPage: React.FC<Props> = (props) => {
  return (
    <Box>
      {/* ヘッダー */}
      <Group gap={12} mb={24}>
        <ThemeIcon variant="transparent">
          <SquaresFourIcon weight="fill" size={36} />
        </ThemeIcon>
        <Title size={24} fw={600} c="#000000CC">
          CRMスコアリング
        </Title>
      </Group>

      <AxisTabs axis={props.axis} onChange={props.onAxisChange} />

      {/* 期間フィルタ */}
      <Box mt={24}>
        <DateRangeFilter
          start={props.dateRange.start}
          end={props.dateRange.end}
          total={props.matrix.total}
          snapshotDate={props.snapshotDate}
          selectedCellCount={props.selectedCells.length}
          onChange={props.onDateRangeChange}
          onSnapshotDateChange={props.onSnapshotDateChange}
        />
      </Box>

      {/* マトリクス */}
      <Box mt={40}>
        {props.matrix.loading ? (
          <Center mih={200}>
            <Loader />
          </Center>
        ) : (
          <ScoringMatrix
            axis={props.axis}
            cells={props.matrix.cells}
            selectedCells={props.selectedCells}
            onToggleCell={props.onToggleCell}
            onClearSelectedCells={props.onClearSelectedCells}
          />
        )}
      </Box>

      {/* 対象ユーザーリスト */}
      <Box mt={40}>
        <SegmentUserList
          clientId={props.clientId}
          axis={props.axis}
          users={props.users.items}
          total={props.users.total}
          page={props.users.page}
          perPage={props.users.perPage}
          loading={props.users.loading}
          searchQuery={props.searchQuery}
          onSearchQueryChange={props.onSearchQueryChange}
          checkedUserIds={props.checkedUserIds}
          onSetCheckedUsers={props.onSetCheckedUsers}
          onPageChange={props.onPageChange}
          onPerPageChange={props.onPerPageChange}
          sort={props.sort}
          onSortChange={props.onSortChange}
          snapshotDate={props.snapshotDate}
          onCsvDownload={props.onCsvDownload}
          csvLoading={props.csvLoading}
        />
      </Box>
    </Box>
  )
}

export default CrmScoringPage
